import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from "@angular/core";
import { SafeUrl } from "@angular/platform-browser";
import { PatientsService } from "../patients.service";
import { Patient } from "../patients/patient";
import { ExamsService } from "../exams.service";
import { PregnancyService } from "../pregnancy.service";
import { AutotextService } from "../autotext.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { LoginService } from "../login.service";
import { VideoCaptureService } from "../video-capture.service";
import { VideoClientService } from "../video-client.service";
import { Router } from "@angular/router";
import { TimerService } from "../timer.service";
import { Subject, Subscription } from "rxjs";
import { GalleryService } from "../gallery.service";
import { Location } from "@angular/common";
import { SignatureService } from "../signature.service";
import { DicomViewerService } from "../dicom-viewer.service";
import { debounceTime } from "rxjs/operators";

@Component({
    selector: "app-exam",
    templateUrl: "./exam.component.html",
    styleUrls: ["./exam.component.scss"],
    standalone: false
})
export class ExamComponent implements OnInit, OnDestroy {
  @ViewChild("videobox") videoElement: ElementRef;
  @ViewChild("imgcanvas") imageCanvas: ElementRef;
  fetuses: number = 1;
  showSide: boolean = false;
  page: string = "Pregnancy";
  pat: Patient;
  showPat = false;
  showgallery = false;
  showcharts = false;
  showprint = false;
  showprintopts = true;
  showInbox = false;
  // Clalit report controls
  clalitConfirm = false;   // cancellation confirmation panel is open
  clalitAck = false;
  clalitBusy = false;
  clalitMessage: string = null;
  recording = false;
  recordLink: SafeUrl;
  CurrentSR: string;
  CurrentInbox: number;
  vidMinified: boolean;
  videoSource: string;
  audioSource: string;
  Stream: MediaStream;
  soundtest: boolean;
  audioInputs: { value: any; text: any }[];
  videoInputs: { value: any; text: any }[];
  videowarn = false;
  SR: SafeHtml;
  noStop = false;
  exitTimeout;
  fullscreen = false;
  ExamSubscription: Subscription;
  showlink = false;
  sub: Subscription;
  takePicSubsctiption: Subscription;
  phototaken: SafeUrl;
  showTimmer;
  messages: string;
  sendonce = false;
  showSelect = false;
  concentForm;
  inform = false;
  // linksent = 0;
  audioLevel: number = 0;
  openDocumentsAdd = false;
  showPrintHistory = false;
  updateExercise$ = new Subject<void>();

  // Exam Signature:
  private examSignedSub: Subscription;
  private alertToSignSub: Subscription;

  showAlertToSign: boolean = false;
  exitToPatSearch: boolean = false;

  // DICOM viewer: shown only when the exam has dicom_studies rows in a clinic that has a
  // GCP archive. Rechecked when media arrive, because studies can land mid-exam.
  dicomStudies = 0;
  dicomViewerUrl: string = null;
  private dicomMediaSub: Subscription;

  constructor(
    private location: Location,
    private patservice: PatientsService,
    public vs: VideoCaptureService,
    private vidClient: VideoClientService,
    public ps: PregnancyService,
    public atS: AutotextService,
    private sanitizer: DomSanitizer,
    public ls: LoginService,
    private router: Router,
    public ts: TimerService,
    public gs: GalleryService,
    public es: ExamsService,
    public signatureService: SignatureService,
    private dicomViewer: DicomViewerService
  ) {
    this.vidMinified = false;
    this.audioInputs = [];
    this.videoInputs = [];
    this.gs.isOpen = false;
    this.ExamSubscription = this.es.examLoaded$.subscribe(async () => {
      if (!this.es.isClosed) {
        this.exitTimeout = setTimeout(() => {
          this.exit();
        }, 120 * 60 * 1000);
      } else {
        if (this.es.ExamType != "Emergency Room") {
          this.showprintopts = false;
          this.showprint = true;
        }
      }
      if (
        this.es.ExamType != "Follicles" &&
        this.es.ExamType != "Gynecology" &&
        this.patservice.getPat().ID != "default" &&
        !this.es.isForm
      )
        this.ps.setExamID(this.es.examID, this.es.CreationTime);
      this.sendonce = this.es.LinkSent;
      this.checkDicomViewer();
    });
    this.dicomMediaSub = this.es.mediaArrived$
      .pipe(debounceTime(5000))
      .subscribe(() => this.checkDicomViewer());
  }

  checkDicomViewer() {
    if (!this.es.examID || this.pat?.ID == "default" || this.es.isForm) {
      this.dicomStudies = 0;
      return;
    }
    const examId = this.es.examID;
    this.dicomViewer.check(examId).subscribe(
      (r) => {
        if (examId != this.es.examID) return;
        this.dicomStudies = r.available && r.url ? r.studies : 0;
        this.dicomViewerUrl = r.available ? r.url : null;
      },
      () => (this.dicomStudies = 0)
    );
  }

  openDicomViewer() {
    if (this.dicomViewerUrl) this.dicomViewer.open(this.dicomViewerUrl);
  }

  async ngOnInit() {
    this.es.loginMissing();
    this.getCountLinks();
    this.pat = this.patservice.getPat();
    //this.recordLink = this.sanitizer.bypassSecurityTrustUrl('ArtisanImage:Start' + this.es.examID);
    this.es.ShowSRs = false;
    this.checkDicomViewer();

    // this.cookie=this.cookieServ.get('connect.sid');
    if (this.pat?.ID == "default") this.page = "Placenta";
    if (this.ls.isCardio) this.page = "Introduction";
    if (this.es.ExamType == "Emergency Room") this.page = null;
    if (this.es.isForm) this.page = "forms";
    if (
      this.ls.Recording == "webrtc" &&
      !this.ls.RemoteRTC &&
      this.pat.ID != "default" &&
      !this.es.isForm &&
      this.es.ExamType != "Emergency Room" &&
      !this.es.isClosed
    ) {
      let inputs = await this.vs.getDevices();
      this.videoInputs = inputs.video;
      this.audioInputs = inputs.audio;
      try {
        let oldv = window.localStorage.getItem("video");
        if (
          oldv &&
          this.videoInputs.find((item) => {
            return item.value == oldv;
          })
        ) {
          this.videoSource = oldv;
        }
        var olda = window.localStorage.getItem("audio");
        if (
          olda &&
          this.audioInputs.find((item) => {
            return item.value == olda;
          })
        ) {
          this.audioSource = olda;
        }
        await this.startVideo();
        if (this.ls.isGastro) {
          this.vs.ExamID = this.es.examID;
          this.vs.openWebSocket(); //for image capture messages
        }
        this.vs._photoS.subscribe((photo) => {
          this.imageCanvas.nativeElement.width = photo.width;
          this.imageCanvas.nativeElement.height = photo.height;
          this.imageCanvas.nativeElement.getContext("2d").drawImage(photo, 0, 0);
          this.imageCanvas.nativeElement.style.display = "block";
          try {
            if (this.showTimmer) clearTimeout(this.showTimmer);
          } catch (e) {
            console.log(e);
          }
          this.showTimmer = setTimeout(() => {
            this.imageCanvas.nativeElement.style.display = "none";
          }, 3000);
        });
      } catch (e) {
        console.log(e);
      }
    }
    if (this.ls.RemoteRTC && !this.es.isClosed) {
      this.vidClient.GotStream.subscribe(() => {
        this.Stream = this.vidClient.Stream;
      });
      this.vidClient.ConnectServer();
    }
    
    // Enable all fields if exam is not signed:
    // if (!isExamSigned) {
    //   this.es.isClosed = false;
    //   this.es.signed = false;
    // }

    // Login for edit:
    if (this.es.isLoginForEdit) {
      this.es.isClosed = false;
      this.showprint = false;
      this.es.signed = false;
    }

    this.examSignedSub = this.es.examSigned$.subscribe((data) => {
      this.es.examObject = data;
      this.signatureService.isExamSigned(this.es.examObject);
    });

    this.alertToSignSub = this.signatureService.alertToSign$.subscribe((shouldAlert) => {
      if (shouldAlert && !this.es.isClosed && this.pat?.ID != 'default') {
        this.showAlertToSign = true;
      }
    });
  }

  ngAfterViewInit() {
    // Get access to the microphone audio stream
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        this.videoElement.nativeElement.srcObject = stream;

        // Create an audio context and analyzer
        const audioContext = new AudioContext();
        const analyzer = audioContext.createAnalyser();
        const microphone = audioContext.createMediaStreamSource(stream);

        microphone.connect(analyzer);

        // Continuously update audio level
        const updateAudioLevel = () => {
          const dataArray = new Uint8Array(analyzer.frequencyBinCount);
          analyzer.getByteFrequencyData(dataArray);
          const average = dataArray.reduce((acc, val) => acc + val, 0) / dataArray.length;
          this.audioLevel = Math.floor((average / 255) * 100); // Convert to 0-100 scale
          requestAnimationFrame(updateAudioLevel);
        };

        audioContext.resume().then(() => {
          updateAudioLevel(); // Start updating audio level
        });
      })
      .catch((error) => {
        console.error("Error accessing microphone:", error);
      });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.exitTimeout) clearTimeout(this.exitTimeout);
    if (this.ls.RemoteRTC) this.vidClient.StopRecording();
    else {
      this.vs.Clean();
      this.vs.closeWebSocket();
    }
    // this.es.exitExam();
    this.ExamSubscription.unsubscribe();
    if (this.dicomMediaSub) this.dicomMediaSub.unsubscribe();
    if (this.sub) this.sub.unsubscribe();
    if (this.takePicSubsctiption) this.takePicSubsctiption.unsubscribe();

    if (this.examSignedSub) {
      this.examSignedSub.unsubscribe();
    }

    if (this.alertToSignSub) {
      this.alertToSignSub.unsubscribe();
    }
  }

  setPage(pg: string) {
    this.page = pg;
    this.ls.tabChanged$.next(pg);
  }

  startForm() {
    this.es.ps.resetPreg();
    var temp = this.es.pregnancies.filter((i) => i.AutoIndex == this.es.ps.pregID);
    if (temp.length > 0) {
      temp = temp[0].forms.filter(
        (i) => i.ExamID == this.es.examID || (!i.ExamID && i.ExamType == this.es.ExamType)
      );
    }
    if (temp.length > 0) this.concentForm = temp[0];
    else this.concentForm = null;

    this.inform = true;
  }

  changeFetuses(n: number) {
    this.fetuses = n;
  }

  record() {
    if (this.ls.RemoteRTC && !this.noStop) {
      this.noStop = true; //don't allow to stop recording in less than 5 secons
      if (this.vidClient.Recording) {
        this.vidClient.StopRecording();
      } else if (!this.vidClient.Recording) {
        this.vidClient.StartRecording();
      }
      setTimeout(() => {
        this.noStop = false;
      }, 5000);
    } else {
      if (!this.noStop) {
        this.noStop = true;
        this.vs.Record(this.es.examID);
        setTimeout(() => {
          this.noStop = false;
        }, 2000);
      }
    }
  }

  isRecording(): boolean {
    if (this.ls.RemoteRTC) return this.vidClient.Recording;
    else return this.vs.recording;
  }

  openGallery(inbox: number) {
    this.CurrentInbox = inbox;
    this.showgallery = true;
  }

  async startVideo() {
    this.Stream = await this.vs.startVideo(this.videoSource, this.audioSource, this.soundtest);
  }

  loadSR(sr: string) {
    this.CurrentSR = sr;
    this.es.getSR(sr).subscribe(
      (data) => {
        // The report is a complete standalone document: <head>, a <style> block and
        // ~1000 class attributes, no scripts. Angular's HTML sanitizer strips exactly
        // those - head, style and class - which is why the report used to render as
        // unstyled run-together text.
        //
        // Sanitizing here was the wrong tool anyway: the content goes into an iframe,
        // which is its own document, so it never executes in this page's context. The
        // iframe carries `sandbox` with no allow-* tokens, giving it an opaque origin
        // with scripting disabled, so even a report that did contain a script could not
        // run it or reach this page. That sandbox is what makes bypassing safe here.
        this.SR = this.sanitizer.bypassSecurityTrustHtml(data);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  exit(patlist = false) {
    this.es.exitExam();
    if (this.ls.isCardio && this.ls.userType == "secretary") {
      this.location.back();
    } else {
      this.router.navigateByUrl(patlist ? "/patsearch" : "/exams");
    }
  }

  handleClose(place: string) {
    const examObject = this.es.examObject;
    const isDoctor = this.es.isDoctor();
    const isExamSigned = this.signatureService.isExamSigned(examObject);
    const isClosed = this.es.isClosed;

    if (isDoctor && !isExamSigned && !isClosed && this.pat?.ID != 'default') {
      this.showAlertToSign = true;
      this.exitToPatSearch = true;
    } else {
      this.es.exitExam();
      if ( this.ls.userType == "secretary") {
      this.location.back();
      return
    }
      this.router.navigateByUrl(place);
    }
  }

  leaveSignAlert() {
    this.showAlertToSign = false;
    this.exit(this.exitToPatSearch ? true : false);
  }

  maximizeVid() {
    this.videoElement.nativeElement.requestFullscreen();
  }

  handleError(error) {
    console.log("navigator.MediaDevices.getUserMedia error: ", error.message, error.name);
  }

  togglefullscreen() {
    this.fullscreen = !this.fullscreen;
  }


  // The server names the file cd<patient ID>.aecb; a non-ASCII ID arrives as filename*=UTF-8''...
  private diskFileName(disposition: string | null): string {
    const star = disposition && /filename\*=UTF-8''([^;]+)/i.exec(disposition);
    if (star) return decodeURIComponent(star[1]);
    const plain = disposition && /filename="?([^";]+)"?/i.exec(disposition);
    return plain ? plain[1] : "cd.aecb";
  }

  getDisk() {
    if (this.messages == "Creating Disk ...") return;
    this.messages = "Creating Disk ...";
    this.es.getDisk().subscribe(
      (response) => {
        this.messages = "Downloading disk";
        setTimeout(() => {
          this.messages = 'When buring disk or onkey ignore the "Not Responding" message';
          setTimeout(() => {
            this.messages = null;
          }, 10000);
        }, 2000);
        const url = URL.createObjectURL(response.body);
        var element = document.createElement("a");
        element.setAttribute("href", url);
        element.setAttribute("download", this.diskFileName(response.headers.get("Content-Disposition")));
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      },
      (err) => {
        this.messages = "Disk Creation failed";
        setTimeout(() => {
          this.messages = null;
        }, 3000);
      }
    );
  }

  closeConcent(event) {
    console.log(event);
    this.inform = false;
  }

  getCountLinks() {
    this.ls.countLinks();
  }

  handleUpdateExercise() {
    this.updateExercise$.next();
  }
  // YYYYMMDDHHMMSS -> dd/MM/yyyy HH:mm
  clalitTime(key: string): string {
    const d = this.es.parseClalitKey(key);
    if (!d) return '';
    const p = (n: number) => String(n).padStart(2, '0');
    return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
  }

  private clalitCall(call, done: string) {
    this.clalitBusy = true;
    this.clalitMessage = null;
    call.subscribe(
      (data) => {
        this.clalitBusy = false;
        this.es.setClalit(data);
        this.clalitMessage = done;
      },
      (err) => {
        this.clalitBusy = false;
        this.clalitMessage = (err && err.error && err.error.error) || 'Clalit request failed';
        this.es.loadClalitStatus();
      }
    );
  }

  clalitUpdate() {
    this.clalitCall(this.es.clalitSend('update'), 'Update sent to Clalit');
  }

  clalitResend() {
    this.clalitCall(this.es.clalitSend('new'), 'Report sent to Clalit');
  }

  openClalitCancel() {
    this.clalitAck = false;
    this.clalitMessage = null;
    this.clalitConfirm = true;
  }

  confirmClalitCancel() {
    if (!this.clalitAck || !this.es.clalit) return;
    this.clalitConfirm = false;
    this.clalitCall(this.es.clalitCancel(this.es.clalit.lastSentKey), null);
  }

  undoClalitCancel() {
    this.clalitCall(this.es.clalitUndoCancel(), 'Cancellation stopped - nothing was sent');
  }

  resendMaccabi() {
    this.es.maccabiResend = false;
    this.es.resendMaccabiReport().subscribe(
      (data) => {
      },
      (err) => {
        this.es.maccabiResend = true;
        console.log(err);
      }
    );
  }

}
